export const checkGrabs = array => array
    .map((item) => {
        const cleaned = {};
        Object.entries(item).forEach(([key, val]) => {
            if (val) {
                cleaned[key] = val;
            }
        });
        return cleaned;
    })
    .filter(({ type, quantity }) => !!type && !!quantity);



// WEBPACK FOOTER //
// ./app/helpers/vessels.js